/**
 * Utility to unregister all service workers - for development mode cleanup
 */

export async function unregisterAllServiceWorkers(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    console.log('Service workers not supported');
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    
    if (registrations.length === 0) {
      console.log('✅ No service workers to unregister');
      return;
    }

    console.log(`🧹 Unregistering ${registrations.length} service worker(s)...`);
    
    for (const registration of registrations) {
      await registration.unregister();
      console.log('✅ Service worker unregistered:', registration.scope);
    }
    
    // Clear all caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
        console.log('✅ Cache deleted:', cacheName);
      }
    }
    
    console.log('✅ All service workers and caches cleared');
  } catch (error) {
    console.error('❌ Failed to unregister service workers:', error);
  }
}

// Auto-unregister service workers in ALL environments
// The old VitePWA service worker causes reload loops in production
if ('serviceWorker' in navigator) {
  unregisterAllServiceWorkers().catch(() => {});
}